import { createTheme } from '@mui/material/styles';
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: "#ffffff",
      light: "#FAFAFA",
    },
    red: {
      main: "#DC143C",
      light: "#FAEAEE",
      lighter: "#FF809A",
    },

    grey: {
      100: "#4A4A4A",
      200: "#2B2626",
      300: "#606060",
      400: "#6E6E6E",
      500: "#4E4E4E"

    },
    background: {
      default: '#FAFAFA',
      paper: '#ffffff',
    },
    text: {
      primary: '#0D0D0D',
      secondary: '#000000',

    },

  },
  typography: {
    h1: {
      // fontSize: '48px',
      fontSize: '35px',
      fontWeight: 700,
      // lineHeight: "60.48px",
      lineHeight: { xs: "40px", lg: "45px" },
    },
    h2: {
      fontSize: { xs: "25px", lg: "30px" },
      fontWeight: 700,
      // lineHeight: "50.4px",
      lineHeight: { xs: "30px", lg: "40px" },
    },
    h3: {
      fontSize: '36px',
      fontWeight: 700,
      lineHeight: "45.36px",

    },
    h4: {
      fontSize: '32px',
      fontWeight: 400,
      lineHeight: "48px",
    },
    h5: {
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: "35.28px",
    },
    h6: {
      fontSize: '22px',
      fontWeight: 400,
      lineHeight: "24px",
      fontFamily: "Poppins"
    },
    body1: {
      fontSize: "16px",
      fontWeight: 400,
      // lineHeight: "30.24px",
      lineHeight: "24.24px",

    },
    body2: {
      fontSize: '14px',
      fontWeight: 400,
      // lineHeight: "30.24px",
      lineHeight: "20.24px",
    }
  },

  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: "text.primary",
        fontSize: "body2",
        fontFamily: "Sora",

      },
    },

    MuiButton: {
      defaultProps: {
        disableElevation: true,
        sx: {
          borderRadius: "12px",
          textTransform: "capitalize",
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "30px",
          // padding: "40px",

          "&.MuiButton-outlined": {
            fontSize: "16px",
            fontWeight: 400,
            color: "red.main",
            backgroundColor: "transparent",
            border: "1px solid #DC143C",
            boxShadow: "0px 4px 4px 0px #00000040",
            // height: "45px"
            lineHeight: "30.36px",
          },

          "&.MuiButton-contained": {
            // minHeight: "40px",
            fontSize: { xs: "14px", md: "20px" },
            fontWeight: "400",
            lineHeight: "35.36px",
            color: "primary.main",
            backgroundColor: "red.main"
          },

          "&.MuiButton-text, &.MuiButton-gost": {
            // minWidth: "400px",
            fontSize: { xs: "14px", md: "20px" },
            fontWeight: 500,
            lineHeight: "35.36px",
            borderRadius: "12px",
            p: "0px 20px",
          },
          "&.MuiButton-text": {
            color: "primary.main",
            backgroundColor: "red.main",
          },

          "&.MuiButton-gost": {
            color: "red.main",
            backgroundColor: "primary.main",
          },

        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 0,
          "&:last-child": {
            paddingBottom: 0,
          },
          boxShadow: "none"
        },
      }
    },

    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-container--top [role=row], & .MuiDataGrid-container--bottom [role=row]": {
            backgroundColor: "#EDEDED", // Apply Royal Blue background
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: "14px",
            fontWeight: "400 !important",
            color: "#000000",
          },
          "& .MuiDataGrid-columnSeparator--resizable": {
            display: "none", // Hide column separator
          },
          "& .MuiDataGrid-sortIcon, & .MuiDataGrid-filterIcon , & .MuiDataGrid-menuIconButton": {
            color: "#fff", // Set icon color to white
          },
          "& .MuiDataGrid-withBorderColor": {
            borderColor: "#B3B3B3 !important", // Change ALL border colors except header
          },
          "& .MuiDataGrid-footerContainer": {
            display: "none !important", // Hides the last pagination element
          },
        },
      },
      defaultProps: {
        pageSizeOptions: [10, 25, 50, 100],
        initialState: {
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        },
        checkboxSelection: false,
        sx(theme) {
          return {
            ".MuiDataGrid-columnHeader": {
              borderRight: "0.5px solid #B3B3B3", // ✅ Adds a right-side border to headers and cells
            },
            "& .MuiDataGrid-columnHeader:last-child, & .MuiDataGrid-cell:last-child": {
              borderRight: "none !important",
            },
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal", // ✅ Allow text wrapping
              wordWrap: "break-word",
              overflowWrap: "break-word",
              display: "flex",
              alignItems: "center", // ✅ Center align vertically
              justifyContent: "start", // ✅ Center align horizontally
              minHeight: "auto", // ✅ Auto height
              textAlign: "start", // ✅ Ensure text is centered inside the cell
              borderRight: "0.5px solid #B3B3B3",
            },
            "& .MuiDataGrid-row": {
              minHeight: "auto !important", // ✅ Ensure rows expand
              height: "auto !important",
            },
            "& .MuiDataGrid-virtualScrollerContent": {
              minHeight: "auto !important", // ✅ Make sure content flows correctly
            }
          };
        },
      },
    },

  },
});


export default theme;
